export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading text-primary-400">麻花影院</span>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              聚合最新电影高清大片资源，包含热门动作片、科幻片、喜剧电影等，免费在线观看更新不断。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-bilibili-line text-sm"></i>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '电影分类', href: '#cards' },
                { label: '影迷评价', href: '#comments' },
                { label: '专题合集', href: '#index' },
                { label: '常见问题', href: '#faq' },
                { label: '热度榜单', href: '#ranking' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-100 mb-4">电影分类</h3>
            <ul className="space-y-2.5">
              {['动作片', '科幻片', '喜剧电影', '悬疑惊悚', '爱情片', '动画电影'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('#cards');
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <p className="text-xs text-background-500">
                &copy; 2026 麻花影院 · 最新电影热门电影大全
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            麻花影院 · 动作片科幻片喜剧高清在线看 · 大片不断更新
          </p>
          <p className="text-xs text-background-500">
            本站内容均为静态展示，不涉及实际播放与数据存储
          </p>
        </div>
      </div>
    </footer>
  );
}